import { render } from "./TgImage.vue?vue&type=template&id=53141f98"
import script from "./TgImage.vue?vue&type=script&lang=js"
export * from "./TgImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__